import {
  KeyboardEventHandler,
  MouseEventHandler,
  MutableRefObject,
  useCallback,
  useState
} from 'react';
import { Key } from 'record-it-utils/utils/Key/Key';
import { useOnOutsideClick } from '../../hooks/useOnOutsideClick';

export function useSelectDropdownVisible({
  inputElementRef,
  dropdownElementRef
}: UseSelectDropdownVisibleOptions): UseSelectDropdownVisibleReturnValue {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleInputClick = useCallback<MouseEventHandler>(() => {
    setDropdownVisible(true);
  }, [setDropdownVisible]);

  const handleInputKeydown = useCallback<KeyboardEventHandler>(
    (event) => {
      if (event.key === Key.ArrowDown || event.key === Key.ArrowUp) {
        setDropdownVisible(true);
      } else if (event.key === Key.Tab) {
        setDropdownVisible(false);
      }
    },
    [setDropdownVisible]
  );

  const handleOptionSelected = useCallback(() => {
    setDropdownVisible(false);
  }, [setDropdownVisible]);

  useOnOutsideClick([inputElementRef, dropdownElementRef], () => {
    setDropdownVisible(false);
  });

  return {
    dropdownVisible,
    handleInputClick,
    handleInputKeydown,
    handleOptionSelected
  };
}

export type UseSelectDropdownVisibleOptions = {
  inputElementRef: MutableRefObject<HTMLElement | null>;
  dropdownElementRef: MutableRefObject<HTMLElement | null>;
};

export type UseSelectDropdownVisibleReturnValue = {
  dropdownVisible: boolean;
  handleInputClick: MouseEventHandler;
  handleInputKeydown: KeyboardEventHandler;
  handleOptionSelected: () => void;
};
